import { createClient } from '@supabase/supabase-js';

// Obter as credenciais do Supabase das variáveis de ambiente
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Verificar se as credenciais estão definidas
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Credenciais do Supabase não encontradas. Verifique o arquivo .env');
}

// Configurações avançadas para persistência de sessão
const persistSessionOptions = {
  persistSession: true,
  autoRefreshToken: true,
  detectSessionInUrl: false, // Desativar detecção de sessão na URL para evitar problemas
  flowType: 'implicit', // Usar fluxo implícito para melhor compatibilidade
  debug: false, // Desativar logs de debug
  multiTab: true, // Permitir múltiplas sessões simultâneas
  localStorage: {
    getItem: (key) => {
      try {
        const value = localStorage.getItem(key);
        return value;
      } catch (error) {
        console.error('Erro ao acessar localStorage:', error);
        return null;
      }
    },
    setItem: (key, value) => {
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        console.error('Erro ao salvar no localStorage:', error);
      }
    },
    removeItem: (key) => {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.error('Erro ao remover do localStorage:', error);
      }
    }
  }
};

// Criar o cliente Supabase com opções de persistência e auto-refresh de tokens
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: persistSessionOptions,
  realtime: {
    params: {
      eventsPerSecond: 1 // Limitar eventos para evitar problemas de desempenho
    }
  },
  global: {
    headers: {
      'X-Client-Info': 'sistema-gestao-municipal'
    }
  },
  // Desativar logs em produção
  logger: process.env.NODE_ENV === 'production' ? {
    error: () => {},
    warn: () => {},
    info: () => {},
    log: () => {},
    debug: () => {}
  } : undefined
});

export default supabase;